import { AppEnvironmentUtil, Environment } from '@as-react/common-utils';
import { I18N_TRANSLATIONS_BASE_PATH } from '../../constants/i18nConstants';
import { i18nConfigurationGeneral } from './i18nConfigurationGeneral';
const isDev = Environment.isDevelopment();
const isPrd = AppEnvironmentUtil.isProduction();
const AEM_USERNAME = 'admin';
const AEM_PASSWORD = 'admin';
const generateBackEndI18nInitOptions = (version, translationEndpoint) => (Object.assign(Object.assign(Object.assign({}, i18nConfigurationGeneral), { preload: i18nConfigurationGeneral.supportedLngs }), {
    backend: Object.assign(Object.assign(Object.assign(Object.assign({}, i18nConfigurationGeneral.backend), { loadPath: `${translationEndpoint}${I18N_TRANSLATIONS_BASE_PATH}`, 
        // path to post missing resources
        addPath: `${translationEndpoint}${I18N_TRANSLATIONS_BASE_PATH}`, queryStringParams: {
            version: version,
        } }), (isDev
        ? {
            customHeaders: {
                Authorization: `Basic ${btoa(`${AEM_USERNAME}:${AEM_PASSWORD}`)}`,
            },
        }
        : {})), { reloadInterval: isPrd
            ? 24 * 60 * 60 * 1000 // 24 hours
            : false }),
}));
export default (version, translationLanguage = '') => generateBackEndI18nInitOptions(version, translationLanguage);
